<template>
  <SelectMenu
    label="Merge Tags"
    :initial-value="mergeTagPlaceholder"
    :options="mergePrettyList"
    :float-dropdown="floatDropdown"
    @selected-option="handleSelect"
  />
</template>

<script setup lang="ts">
import { mergePrettyList, type MergePretty } from '../MergeTagOptions';
import { mergeTagPlaceholder } from './mergeTagPlaceholder';
import { stringToEnum } from '@/lib/typeParser';

type MergeTagSelectProps = {
  floatDropdown?: boolean;
  prettyTags?: boolean;
};

const { floatDropdown = false } = defineProps<MergeTagSelectProps>();

type Emits = {
  'selected-tag': [val: MergePretty];
};

const handleSelect = (val: string) => {
  const mergePretty = stringToEnum(val, mergePrettyList);
  if (mergePretty) emit('selected-tag', mergePretty);
};

const emit = defineEmits<Emits>();
</script>
